var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "loader-mw" }, [
      _c("div", { staticClass: "background" }),
      _c(
        "div",
        { staticClass: "loader" },
        [
          _vm.activeClose
            ? _c("div", { staticClass: "close-x", on: { click: _vm.close } }, [
                _c("img", {
                  attrs: { src: require("../../../assets/img/icon-delete.svg") }
                })
              ])
            : _vm._e(),
          _c("lottie-animation", {
            ref: "anim",
            attrs: {
              path: "Loader_Mashup-Web.json",
              width: 256,
              height: 256,
              loop: true,
              autoPlay: true
            }
          }),
          !_vm.unlimitedProgress
            ? _c("p", { staticClass: "progress" }, [
                _vm._v(_vm._s(_vm.progress) + "%")
              ])
            : _vm._e(),
          _vm.detail
            ? _c("p", { staticClass: "detail" }, [_vm._v(_vm._s(_vm.detail))])
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }